// Required for DatePicker fixes
/* eslint-disable oyster/frog-forbidden-date */
export function convertUTCToLocalDate(date: Date) {
  date = new Date(date)
  date = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  )
  return date
}

export function convertLocalToUTCDate(date: Date) {
  date = new Date(date)
  date = new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    ),
  )
  return date
}
